import React from 'react';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerProps {
  label: string;
  value: string; // ISO date string or ''
  onChange: (e: { target: { name: string; value: string } }) => void;
  name: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

const DatePickerField: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  name,
  required = false,
  error = false,
  helperText = '',
  disabled = false,
}) => {
  const handleChange = (newValue: Dayjs | null) => {
    onChange({
      target: {
        name,
        value: newValue ? newValue.format('YYYY-MM-DD') : '',
      },
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        label={label}
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth: true,
            required,
            error,
            helperText,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerField;
